var _path, _path2, _ellipse, _ellipse2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBellicon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 27,
    viewBox: "0 0 20 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8759 20.8364C11.8759 21.8391 11.0436 22.6548 10.0209 22.6548H9.97509C8.95236 22.6548 8.12012 21.8391 8.12012 20.8364H6.74609C6.74609 22.5818 8.19458 24.0016 9.97509 24.0016H10.0209C11.8014 24.0016 13.2499 22.5818 13.2499 20.8364H11.8759Z",
    fill: "black",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8908 19.8875L16.939 16.9113V13.0912C16.939 9.30385 13.8261 6.22266 10 6.22266C6.17373 6.22266 3.06105 9.30385 3.06105 13.0912V16.9113L1.10922 19.8872C0.973179 20.0944 0.963584 20.3579 1.08403 20.5741C1.20447 20.7902 1.43556 20.9249 1.68701 20.9249H18.3131C18.5645 20.9249 18.7956 20.7902 18.9158 20.5743C19.0364 20.3582 19.0268 20.0947 18.8908 19.8875ZM2.94537 19.5782L4.32585 17.4732C4.39707 17.3648 4.43509 17.2381 4.43509 17.1091V13.0912C4.43509 10.0466 6.93153 7.56945 10 7.56945C13.0687 7.56945 15.5649 10.0466 15.5649 13.0912V17.1091C15.5649 17.2381 15.6027 17.3645 15.674 17.4732L17.0544 19.5782H2.94537Z",
    fill: "black",
    stroke: "black"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.2361,
    cy: 2.3214,
    rx: 2.60526,
    ry: 2.3214,
    fill: "black"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.2369,
    cy: 2.32032,
    rx: 1.18421,
    ry: 1.05518,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellicon);
export default __webpack_public_path__ + "static/media/bellicon.7a85b85fc6cf99780d0e0c51b41dbb33.svg";
export { ForwardRef as ReactComponent };